document.querySelectorAll('.splash').forEach((splash) => {
  const images = splash.querySelectorAll('img');
  let currentIndex = 0;

  const showImage = () => {
    images.forEach((img) => img.classList.remove('visible'));
    images[currentIndex].classList.add('visible');
    currentIndex = (currentIndex + 1) % images.length;
  };

  setTimeout(() => {
    setInterval(showImage, 1000 / 12.5);
  }, Math.random() * 1000);
});
